document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  var toggle = event.target.closest('[data-nav-toggle]');
  if (!toggle) return;

  var drawer = document.querySelector('[data-mobile-nav]');
  if (!drawer) return;

  var isOpen = drawer.hasAttribute('hidden') === false;
  if (isOpen) {
    drawer.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', 'false');
  } else {
    drawer.removeAttribute('hidden');
    toggle.setAttribute('aria-expanded', 'true');
  }
});

document.addEventListener('change', function (event) {
  var variantInput = event.target.closest('[data-variant-input]');
  if (!variantInput) return;

  var form = variantInput.closest('form');
  if (!form) return;

  var productInfo = variantInput.closest('.product-info') || form;
  var price = productInfo.querySelector('[data-product-price]');
  var compare = productInfo.querySelector('[data-product-compare]');
  var submit = form.querySelector('[data-product-submit]');
  var submitLabel = form.querySelector('[data-product-submit-label]');
  var isAvailable = variantInput.dataset.variantAvailable === 'true';

  if (price) price.textContent = variantInput.dataset.variantPrice || '';
  if (compare) {
    compare.textContent = variantInput.dataset.variantCompare || '';
    compare.hidden = !variantInput.dataset.variantCompare;
  }
  if (submit) submit.disabled = !isAvailable;
  if (submitLabel && submit) submitLabel.textContent = isAvailable ? submit.dataset.addLabel : submit.dataset.soldOutLabel;
});
